export default __webpack_public_path__ + "static/media/mobile-transparent-icon.c47cb5b3.svg";